var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 175,
    height: 50,
    viewBox: "0 0 175 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XLR8 Logo-w 1",
    clipPath: "url(#clip0_0_525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M53.0048 0.258333H59.2139V38.2583C59.2128 38.4188 59.2438 38.5779 59.305 38.7265C59.3663 38.8751 59.4566 39.0102 59.5707 39.124C59.6849 39.2379 59.8207 39.3283 59.9703 39.3899C60.1199 39.4516 60.2803 39.4833 60.4423 39.4833H78.9519V45.05H56.4627C55.5426 45.0412 54.6631 44.673 54.0155 44.0254C53.368 43.3778 53.0048 42.5031 53.0048 41.5917V0.258333Z",
    fill: "#006C35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M121.196 45.05L112.219 30.9667C111.184 31.0583 110.343 31.1 109.695 31.1H98.1935V45.05H91.9928V0.258333H109.661C115.416 0.258333 119.853 1.56111 122.971 4.16667C126.09 6.77222 127.652 10.4944 127.657 15.3333C127.78 18.5723 126.899 21.7709 125.133 24.5C123.345 27.0416 120.765 28.9326 117.788 29.8833L128.322 45.05H121.196ZM109.695 25.5333C113.576 25.5333 116.549 24.7 118.613 23.0333C120.677 21.3667 121.712 18.8833 121.718 15.5833C121.718 12.3833 120.683 9.96111 118.613 8.31667C116.543 6.67222 113.571 5.84444 109.695 5.83333H98.1935V25.5333H109.695Z",
    fill: "#006C35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M168.808 3.04167C170.091 4.01615 171.12 5.28174 171.806 6.73194C172.493 8.18214 172.818 9.77449 172.754 11.375C172.788 13.465 172.142 15.5106 170.911 17.2083C169.6 18.9721 167.808 20.3281 165.745 21.1167C168.391 21.8557 170.755 23.3585 172.535 25.4333C174.177 27.4245 175.051 29.9293 175 32.5C175.068 34.315 174.69 36.1193 173.897 37.757C173.104 39.3947 171.92 40.8166 170.448 41.9C167.414 44.2111 163.291 45.3639 158.081 45.3583C152.87 45.3528 148.744 44.2111 145.704 41.9333C144.237 40.8673 143.054 39.4617 142.261 37.8392C141.468 36.2167 141.087 34.4266 141.153 32.625C141.099 30.0136 141.995 27.4702 143.677 25.4583C145.516 23.3528 147.947 21.8383 150.66 21.1083C148.531 20.2763 146.666 18.8952 145.258 17.1083C143.981 15.3989 143.312 13.318 143.357 11.1917C143.297 9.61291 143.624 8.04332 144.31 6.61688C144.996 5.19044 146.02 3.9495 147.294 3C149.919 1 153.495 0 158.022 0C162.548 0 166.143 1.01389 168.808 3.04167ZM149.945 26.0083C149.007 26.6838 148.251 27.5777 147.745 28.6111C147.239 29.6445 146.997 30.7856 147.042 31.9333C146.985 33.1317 147.218 34.3262 147.723 35.4166C148.228 36.507 148.99 37.4615 149.945 38.2C151.88 39.6944 154.595 40.4417 158.089 40.4417C161.583 40.4417 164.284 39.6944 166.191 38.2C167.152 37.4779 167.922 36.5359 168.435 35.4546C168.947 34.3734 169.188 33.1852 169.136 31.9917C169.177 30.8365 168.93 29.6891 168.416 28.6512C167.903 27.6133 167.138 26.7169 166.191 26.0417C164.228 24.5917 161.505 23.8667 158.022 23.8667C154.538 23.8667 151.846 24.5806 149.945 26.0083ZM151.139 6.4C150.319 7.01897 149.662 7.82455 149.222 8.74855C148.783 9.67255 148.575 10.6878 148.615 11.7083C148.569 12.7393 148.774 13.7661 149.213 14.7018C149.653 15.6375 150.313 16.4545 151.139 17.0833C152.822 18.3667 155.139 19.0083 158.089 19.0083C161.039 19.0083 163.342 18.3667 164.996 17.0833C165.804 16.4439 166.447 15.6225 166.87 14.6876C167.293 13.7527 167.484 12.7313 167.428 11.7083C167.475 10.6937 167.277 9.68253 166.849 8.75917C166.422 7.83582 165.778 7.02697 164.971 6.4C163.339 5.11667 161.036 4.475 158.064 4.475C155.091 4.475 152.783 5.11667 151.139 6.4Z",
    fill: "#006C35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M38.3738 0.258333H31.0709L22.22 12.625L25.5096 18.3167L38.3738 0.258333Z",
    fill: "url(#paint0_linear_0_525)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.23558 0.258333H0L13.1418 18.8583L16.4231 13.1667L7.23558 0.258333Z",
    fill: "url(#paint1_linear_0_525)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M26.3846 31.7833C25.4852 31.3614 24.5024 31.1422 23.5072 31.1417C21.9844 31.1417 20.5877 31.6333 18.6442 31.8333H18.1899C17.6375 31.8422 17.0887 31.7431 16.5749 31.5418C16.0611 31.3405 15.5923 31.041 15.1954 30.6602C14.7985 30.2795 14.4812 29.8251 14.2617 29.3229C14.0421 28.8207 13.9246 28.2805 13.9159 27.7333C14 25.725 16.3305 23.9333 18.375 23.3583C19.1124 23.155 19.8729 23.0457 20.6382 23.0333C23.7091 23.0333 26.3341 24.875 28.2103 26.7833L19.4856 11.7417L9.25481 29.5333L0.252404 45.05H2.84375H3.05409C13.3522 44.5833 13.5709 36.5833 19.4856 36.5833C25.5601 36.5833 25.619 45.05 36.8089 45.05H38.7019C38.7019 45.05 33.4856 34.5917 26.3846 31.7833Z",
    fill: "#006C35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_525",
    x1: 20.6887,
    y1: 19.9,
    x2: 30.283,
    y2: 6.25499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006C35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_525",
    x1: 18.7957,
    y1: 20.0667,
    x2: 10.5707,
    y2: 9.82299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006C35"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.781e8bb8a6dd2b2663a6408b4adab29c.svg";
export { ForwardRef as ReactComponent };